const COLORS: Record<string, string> = {
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  green: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  red: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  orange: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
  yellow: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300',
  gray: 'bg-gray-100 text-gray-600 dark:bg-gray-700/50 dark:text-gray-300',
  purple: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  teal: 'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300',
}

export function MockBadge({ children, color = 'gray' }: { children: string; color?: string }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium select-none ${COLORS[color] ?? COLORS.gray}`}
    >
      {children}
    </span>
  )
}

export function MockStatusBadge({ status }: { status: string }) {
  const map: Record<string, { label: string; color: string }> = {
    NEW: { label: 'Новая', color: 'blue' },
    IN_PROGRESS: { label: 'В работе', color: 'orange' },
    IN_QUEUE: { label: 'В работе', color: 'blue' },
    SENT_TO_PROCUREMENT: { label: 'В закупку', color: 'purple' },
    QUOTATION_READY: { label: 'Готова к КП', color: 'green' },
    QUOTATION_CREATED: { label: 'КП создано', color: 'teal' },
    QUOTE_SENT: { label: 'КП отправлено', color: 'teal' },
    CLOSED_WON: { label: 'Счёт', color: 'green' },
    CLOSED_LOST: { label: 'Отказ', color: 'red' },
    ARCHIVED: { label: 'Архив', color: 'gray' },
    NO_RESPONSE: { label: 'Нет ответа', color: 'gray' },
    FOUND: { label: 'Найден', color: 'orange' },
    NOT_FOUND: { label: 'Не найдено', color: 'gray' },
  }
  const item = map[status] ?? { label: status, color: 'gray' }
  return <MockBadge color={item.color}>{item.label}</MockBadge>
}

export function MockPriorityBadge({ priority }: { priority: 'HIGH' | 'MEDIUM' | 'LOW' }) {
  const map = {
    HIGH: { l: 'Высокий', c: 'red' },
    MEDIUM: { l: 'Средний', c: 'orange' },
    LOW: { l: 'Низкий', c: 'gray' },
  }
  const i = map[priority]
  return <MockBadge color={i.c}>{i.l}</MockBadge>
}

export function MockCategoryBadge({ cat }: { cat: 'A' | 'B' | 'C' }) {
  const map = { A: 'red', B: 'orange', C: 'gray' }
  return <MockBadge color={map[cat]}>{cat}</MockBadge>
}
